export enum AccessKeyMode {
  OFF = "off",
  OPTIONAL = "opt",
  REQUIRED = "req",
}
